<template>
  <tr :class="caseRowStyle">
    <td v-if="!caseDpUrl">
      {{item.caseInfo.title | NoEmpty}}
      <a :href="caseMccUrl"
         target="_blank"
         class="caseServicesLink">
        <v-icon small @click.stop=''>fa-file-invoice-dollar</v-icon>
      </a>
    </td>
    <td v-else>
      <a :href="caseDpUrl" target="_blank" @click.stop=''>
        {{item.caseInfo.title}}
      </a>
      <a :href="caseMccUrl"
         target="_blank"
         class="caseServicesLink">
        <v-icon small @click.stop=''>fa-file-invoice-dollar</v-icon>
      </a>
    </td>
    <td>
      {{item.caseInfo.status}}
    </td>
    <td>
      Created date: {{item.caseInfo.creationDatetime | DateWithMinutes | NoEmpty }}
      <br/>
      Materials received: {{item.caseInfo.receiptMaterialsDatetime | DateWithMinutes | NoEmpty }}
      <br/>
      Report validated: {{item.caseInfo.reportValidationEndedDate | DateWithMinutes | NoEmpty }}
    </td>
    <td>
      {{item.caseInfo.patientName}}
    </td>
    <td>
      <client-info :client-id="item.caseInfo.clientId"/>
    </td>
    <td>
      {{item.caseInfo.comment | NoEmpty}}
    </td>
    <td>
      <pretty-amount :amount="summaryExecutedPrice"/>
    </td>
    <td>
      <modal-case-service-log
        :case-id="item.caseInfo.id"
        :case-title="item.caseInfo.title"/>
      <case-invoice-operations :invoice-id="invoiceId"
                               :affected-services="item.affectedServices"
                               :log="item.log"/>
      <!--
            <attach-logs-to-invoice-form :invoice-id="invoiceId"
                                         :affected-services="item.affectedServices"
                                         :log="item.log"/>
            <detach-logs-to-invoice-form :invoice-id="invoiceId"
                                         :affected-services="item.affectedServices"
                                         :log="item.log"/>
      -->
    </td>
    <td>
      <services-info :log="item.log"
                     :affected-services="item.affectedServices"/>
    </td>
    <td>
      <material-list :case-info="item.caseInfo"
                     :case-anomalies="item.caseAnomalies"/>
    </td>
  </tr>
</template>

<script>
  import AsyncData from "../../Ui/AsyncData";
  import ClientInfo from "../../Sales/case/ClientInfo";
  import ServicesInfo from "./../ServicesInfo";
  import MaterialList from "./../MaterialList";
  import DateWithMinutes from '../../Filters/DateWithMinutes.js'
  import NoEmpty from '../../Filters/NoEmpty'
  import ModalJsonView from "../../Ui/ModalJsonView";
  import ModalCaseServiceLog from "../../Sales/case/ModalCaseServiceLog";
  import PrettyAmount from '../../../components/Ui/PrettyAmount'
  import {calculateExecutedPrice, resolveCaseServicePageUrl, resolveDpCasePageUrl} from "../utils";
  import InvoiceCandidateLogItem from './InvoiceCandidateLogItem'
  import AttachLogsToInvoiceForm from "./AttachLogsToInvoiceForm";
  import DetachLogsToInvoiceForm from "./DetachLogsToInvoiceForm";
  import CaseInvoiceOperations from "./CaseInvoiceOperations";

  export default {
    name: 'invoice-candidate-log-item',
    components: {
      AsyncData,
      ServicesInfo,
      MaterialList,
      ClientInfo,
      ModalJsonView,
      ModalCaseServiceLog,
      PrettyAmount,
      InvoiceCandidateLogItem,
      AttachLogsToInvoiceForm,
      DetachLogsToInvoiceForm,
      CaseInvoiceOperations
    },
    props: {
      item: {
        type: Object,
        required: true
      },
      invoiceId: {
        type: Number,
        required: true
      }
    },
    filters: {
      NoEmpty,
      DateWithMinutes
    },
    data() {
      return {}
    },
    computed: {
      caseDpUrl() {
        if (!this.item.caseInfo.dpId) {
          return null
        }

        return resolveDpCasePageUrl(this.item.caseInfo.dpId)
      },
      caseMccUrl() {
        return resolveCaseServicePageUrl(this.$router, this.item.caseInfo.id)
      },
      summaryExecutedPrice() {
        return calculateExecutedPrice(this.item)
      },
      affectedLogIds() {
        return this.item.affectedServices.list
          .map(it => it.affectedLogRecordIds)
          .reduce((acc, item) => {
            acc.push(...item);
            return acc
          }, [])
      },
      affectedExecutedLogs() {
        return this.item.log
          .filter(it => {
            return _.includes(this.affectedLogIds, it.id) && it.event === 'ChangeExecuted'
          });
      },
      isCaseFullProcessed() {
        for (let affectedExecutedLog of this.affectedExecutedLogs) {
          if (!affectedExecutedLog.metadata || !affectedExecutedLog.metadata.invoiceInfo) {
            return false
          }
        }
        return true
      },
      caseRowStyle() {
        if (!this.isCaseFullProcessed) {
          return 'unprocessedCase';
        }

        return '';
      },
    }
  }
</script>

<style scoped>
  .unprocessedCase {
    background: rgba(0, 182, 255, 0.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/analytics/invoices/InvoiceCandidateLogItem.vue